import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.detectAndSaveTimezone()
  }

  detectAndSaveTimezone() {
    // Get the user's timezone from the browser
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    
    // Check if we've already saved this timezone
    const savedTimezone = localStorage.getItem('user_timezone')
    
    if (savedTimezone !== timezone) {
      // Save to localStorage
      localStorage.setItem('user_timezone', timezone)
      
      // Send to server to save in user profile
      fetch('/update_timezone', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ timezone: timezone })
      }).catch(error => {
        console.error('Failed to update timezone:', error)
      })
    }
  }
}

